var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "account-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195.52 195.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "cls-1",
    d: "M37.64,147.62a101.76,101.76,0,0,1,27.86-15,97.36,97.36,0,0,1,64.52,0,101.62,101.62,0,0,1,27.86,15,75.29,75.29,0,0,0,13.32-22.73A76.58,76.58,0,0,0,176,97.76q0-32.51-22.85-55.36T97.76,19.55q-32.51,0-55.36,22.85T19.55,97.76a76.58,76.58,0,0,0,4.77,27.13A75.71,75.71,0,0,0,37.64,147.62Zm60.12,47.9a95.12,95.12,0,0,1-38.13-7.7A97.61,97.61,0,0,1,7.7,135.89,95.29,95.29,0,0,1,0,97.76,95.29,95.29,0,0,1,7.7,59.63,97.7,97.7,0,0,1,59.63,7.7,95.29,95.29,0,0,1,97.76,0a95.29,95.29,0,0,1,38.13,7.7,97.61,97.61,0,0,1,51.93,51.93,95.12,95.12,0,0,1,7.7,38.13,95.12,95.12,0,0,1-7.7,38.13,97.52,97.52,0,0,1-51.93,51.93A95.12,95.12,0,0,1,97.76,195.52Zm0-19.55a77.41,77.41,0,0,0,24.44-3.79,73.51,73.51,0,0,0,21-10.87,73.54,73.54,0,0,0-21-10.88,77.41,77.41,0,0,0-24.44-3.79,77.45,77.45,0,0,0-24.44,3.79,73.67,73.67,0,0,0-21,10.88,73.64,73.64,0,0,0,21,10.87A77.45,77.45,0,0,0,97.76,176Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "cls-2",
    d: "M122,47.79a33.05,33.05,0,0,0-24.32-9.9A33.81,33.81,0,0,0,63.47,72.11a33.81,33.81,0,0,0,34.21,34.22A33.81,33.81,0,0,0,131.9,72.11,33.07,33.07,0,0,0,122,47.79ZM111.44,85.86a19.69,19.69,0,0,1-27.51,0,18.69,18.69,0,0,1-5.6-13.75A19.12,19.12,0,0,1,97.68,52.76,19.11,19.11,0,0,1,117,72.11,18.68,18.68,0,0,1,111.44,85.86Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.d5fe71df8360eedba9bc0e80f9de6cfd.svg";
export { ForwardRef as ReactComponent };